export const membersTabs = {
  players: 'players',
  clans: 'clans',
  organizers: 'organizers',
}

export type MembersTab = keyof typeof membersTabs
